import { Component, ElementRef, OnInit, Renderer, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Market } from '../../api/models/market-model';
import { MarketService } from '../../api/services/market.service';
import { ProjectService } from '../../api/services/project.services';

@Component({
  selector: 'app-bulk-project-upload',
  templateUrl: './bulk-project-upload.component.html',
  styleUrls: ['./bulk-project-upload.component.scss']
})
export class BulkProjectUploadComponent implements OnInit {

  @ViewChild('downloadAnchor') anchor: ElementRef;

  atcType: string = "Tower";
  atcMarketType: string;
  hasFile = false;
  fileId: string;
  errorCreatingByFile = false;
  errorMessage: string;
  markets: Market[];
  selectedMarketId: string = "NA";

  constructor(
    public projectService: ProjectService,
    private marketService: MarketService,
    private renderer: Renderer,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    if (this.atcType == 'Tower') {
      this.atcMarketType = 'ATC_TOWER';
    }
    this.marketService.getMarketsByMarketType(this.atcMarketType).subscribe(mkts => {
      this.markets = mkts;
    });
   }

  setATCType(atcType: string) {
    this.atcType = atcType;
  }

  downloadTemplate() {
    this.renderer.invokeElementMethod(this.anchor.nativeElement, 'click', []);
  }

  onImportFileUploaded(id: string) {
    this.hasFile = true;
    this.fileId = id;
      this.projectService.uploadBulkProjectsFile(this.fileId, this.selectedMarketId, this.atcType).subscribe(() => {
        this.hasFile = false;
        this.onUploadSuccess("Project Upload");
      }, error => {
        this.errorCreatingByFile = true;
        this.errorMessage = error.error.message;
      });
  }

  private onUploadSuccess(message: string) {
    this.toastr.success(message, 'Succcess!', {
      timeOut: 2000,
      positionClass: 'toast-bottom-right'
    });
  }

  onMarketChange(id: string) {
    this.selectedMarketId = id;
    this.errorCreatingByFile = false;
    this.hasFile = false;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/bulk-project-upload/bulk-project-upload.component.ts